import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import permission from './modules/permission'
import listState from './modules/listState'
import dashboard from './modules/dashboard'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    permission,
    listState,
    dashboard
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js